import {
    Box,
    Button,
    FormControl,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    List,
    ListItem,
    MenuItem,
    OutlinedInput,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { REACT_APP_BACKEND_URL } from "../../Utils/Language/urlBase";
import useAuthHeader from "react-auth-kit/hooks/useAuthHeader";
import { useNavigate } from "react-router";

const AddBuyInvoice = () => {
    const [otherParties, setOtherParties] = useState([]);
    const [search, setSearch] = useState("");
    const [otherPartyId, setOtherPartyId] = useState(0);
    const [isDisabled, setIsDisabled] = useState(false);

    const [stockLocations, setStockLocations] = useState([]);
    const [isDone, setIsDone] = useState(false);
    const [items, setItems] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const authHeader = useAuthHeader();
    // useEffect(() => {
    //     const fetOtherParties = async () => {
    //         const resp = await fetch(`${REACT_APP_BACKEND_URL}/otherparty/`, {
    //             method: "GET",
    //             headers: {
    //                 Authorization: authHeader,
    //                 "Content-Type": "application/json",
    //             },
    //         });
    //         const result = await resp.json();
    //         console.log(result);
    //         setOtherParties(result.otherParties);
    //     };
    //     fetOtherParties();
    // }, []);

    useEffect(() => {
        const fetchItems = async () => {
            const resp = await fetch(`${REACT_APP_BACKEND_URL}/items/`, {
                method: "GET",
                headers: {
                    Authorization: authHeader,
                    "Content-Type": "application/json",
                },
            });

            const result = await resp.json();
            console.log(result);
            setItems(result.data);
            setOtherParties(result.otherParties);
            setStockLocations(result.stockLocations);
        };

        fetchItems();
    }, []);

    const handleSelectItems = (item) => {
        setSelectedItems((prev) => {
            if (prev.find((selectedItem) => selectedItem.id === item.id)) {
                return prev.map((selectedItemsPrev) => {
                    if (selectedItemsPrev.id === item.id) {
                        return {
                            ...item,
                            quantity: selectedItemsPrev.quantity + 1,
                        };
                    } else {
                        return selectedItemsPrev;
                    }
                });
            } else {
                return [...prev, { ...item, quantity: 1 }];
            }
        });
    };
    const navigate = useNavigate();

    const handleBuyInvoiceSave = async () => {
        setIsDisabled(true);
        const resp = await fetch(
            `${REACT_APP_BACKEND_URL}/invoices/buyInvoice`,
            {
                method: "POST",
                body: JSON.stringify({ items: selectedItems, otherPartyId }),
                headers: {
                    Authorization: authHeader,
                    "Content-Type": "application/json",
                },
            }
        );
        const result = await resp.json();

        navigate("/BuyInvoices/" + result.buyInvoice.id);

        setIsDisabled(false);

        console.log(result);
    };
    return (
        <Box padding={2} display="flex" flexDirection="row" gap={3}>
            {!isDone ? (
                <>
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="flex-start"
                        width={300}
                    >
                        <Typography mb={4}>Add Buy Invoice</Typography>
                        {otherParties.length > 0 && (
                            <Select
                                size="small"
                                defaultValue={otherParties[0].id}
                                fullWidth
                                value={otherPartyId}
                                onChange={(e) =>
                                    setOtherPartyId(e.target.value)
                                }
                            >
                                {otherParties.map((party) => (
                                    <MenuItem key={party.id} value={party.id}>
                                        {party.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}

                        <TextField
                            sx={{ mt: 4 }}
                            onChange={(e) => setSearch(e.target.value)}
                            label="Search Items"
                            size="small"
                            fullWidth
                        />
                        <Typography mt={5}>Items</Typography>
                        {items.length > 0 && (
                            <List
                                sx={{
                                    width: "100%",
                                    overflowY: "auto",
                                    height: "200px",
                                }}
                            >
                                {items
                                    .filter(({ name }) =>
                                        name.toLowerCase().includes(search)
                                    )
                                    .map((item) => {
                                        return (
                                            <ListItem
                                                key={item.id}
                                                sx={{
                                                    background: "#77f",
                                                    width: "100%",
                                                    color: "white",
                                                    borderRadius: "10px",
                                                    cursor: "pointer",
                                                    mb: 1,
                                                }}
                                                onClick={() =>
                                                    handleSelectItems(item)
                                                }
                                            >
                                                <span>{item.name}</span>
                                                <IconButton></IconButton>
                                            </ListItem>
                                        );
                                    })}
                            </List>
                        )}
                    </Box>
                    <Box
                        flexGrow={1}
                        border="1px solid #666"
                        borderColor="#666"
                        boxShadow="3px 3px 3px #5555"
                        height={400}
                        display="flex"
                        flexDirection="column"
                    >
                        <Typography ml={2} mt={2}>
                            Selected Items
                        </Typography>
                        <TableContainer
                            sx={{ overflowY: "auth", height: "300px" }}
                        >
                            <Table title="Selected Items">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Item Name</TableCell>
                                        <TableCell>Quantity</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedItems.map((item) => (
                                        <TableRow key={item.id}>
                                            <TableCell>{item.name}</TableCell>
                                            <TableCell>
                                                <Input
                                                    value={item.quantity}
                                                    type="number"
                                                    style={{ width: "40px" }}
                                                    onChange={(e) => {
                                                        const value =
                                                            e.target.value;
                                                        console.log({ value });
                                                        if (
                                                            value === "" ||
                                                            value === 0
                                                        ) {
                                                            setSelectedItems(
                                                                (prev) =>
                                                                    prev.filter(
                                                                        (
                                                                            selItem
                                                                        ) =>
                                                                            selItem.id !==
                                                                            item.id
                                                                    )
                                                            );
                                                            return;
                                                        }
                                                        const selectedItem =
                                                            selectedItems.find(
                                                                ({ id }) =>
                                                                    id ===
                                                                    item.id
                                                            );

                                                        const filteredSelectedItems =
                                                            selectedItems.filter(
                                                                ({ id }) =>
                                                                    id !==
                                                                    item.id
                                                            );

                                                        setSelectedItems([
                                                            ...filteredSelectedItems,
                                                            {
                                                                ...selectedItem,
                                                                quantity: value,
                                                            },
                                                        ]);
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Button
                            onClick={() => {
                                setIsDone(true);
                                setSelectedItems((prev) =>
                                    prev.map((item) => ({
                                        ...item,
                                        price: item.price || 0,
                                    }))
                                );
                            }}
                        >
                            Done
                        </Button>
                    </Box>
                </>
            ) : (
                <>
                    <Box
                        flexGrow={1}
                        border="1px solid #666"
                        borderColor="#666"
                        boxShadow="3px 3px 3px #5555"
                        height={400}
                        display="flex"
                        flexDirection="column"
                    >
                        <Typography ml={2} mt={2}>
                            Selected Items Summary
                        </Typography>
                        <TableContainer
                            sx={{ overflowY: "auto", height: "300px" }}
                        >
                            <Table title="Selected Items Summary">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Item Name</TableCell>
                                        <TableCell>Quantity</TableCell>
                                        <TableCell>Price</TableCell>
                                        <TableCell>Expiry Date</TableCell>
                                        <TableCell>Stock Location</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedItems.map((item) => (
                                        <TableRow key={item.id}>
                                            <TableCell>{item.name}</TableCell>
                                            <TableCell>
                                                {item.quantity}
                                            </TableCell>
                                            <TableCell>
                                                <FormControl
                                                    fullWidth
                                                    sx={{ m: 1 }}
                                                >
                                                    <InputLabel htmlFor="outlined-adornment-amount">
                                                        Amount
                                                    </InputLabel>
                                                    <OutlinedInput
                                                        id="outlined-adornment-amount"
                                                        startAdornment={
                                                            <InputAdornment position="start">
                                                                $
                                                            </InputAdornment>
                                                        }
                                                        label="Amount"
                                                        type="number"
                                                        value={item.price || 0}
                                                        style={{
                                                            width: "150px",
                                                        }}
                                                        onChange={(e) => {
                                                            const value =
                                                                e.target.value;
                                                            setSelectedItems(
                                                                (prev) =>
                                                                    prev.map(
                                                                        (
                                                                            selItem
                                                                        ) =>
                                                                            selItem.id ===
                                                                            item.id
                                                                                ? {
                                                                                      ...selItem,
                                                                                      price: value,
                                                                                  }
                                                                                : selItem
                                                                    )
                                                            );
                                                        }}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                            <TableCell>
                                                <Input
                                                    type="date"
                                                    value={
                                                        item.expiryDate || ""
                                                    }
                                                    onChange={(e) => {
                                                        const value =
                                                            e.target.value;
                                                        setSelectedItems(
                                                            (prev) =>
                                                                prev.map(
                                                                    (selItem) =>
                                                                        selItem.id ===
                                                                        item.id
                                                                            ? {
                                                                                  ...selItem,
                                                                                  expiryDate:
                                                                                      value,
                                                                              }
                                                                            : selItem
                                                                )
                                                        );
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    value={
                                                        item.stockLocationId ||
                                                        ""
                                                    }
                                                    onChange={(e) => {
                                                        const value =
                                                            e.target.value;
                                                        setSelectedItems(
                                                            (prev) =>
                                                                prev.map(
                                                                    (selItem) =>
                                                                        selItem.id ===
                                                                        item.id
                                                                            ? {
                                                                                  ...selItem,
                                                                                  stockLocationId:
                                                                                      value,
                                                                              }
                                                                            : selItem
                                                                )
                                                        );
                                                    }}
                                                >
                                                    {stockLocations.map(
                                                        (location) => (
                                                            <MenuItem
                                                                key={
                                                                    location.id
                                                                }
                                                                value={
                                                                    location.id
                                                                }
                                                            >
                                                                {location.name}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Button fullWidth onClick={() => setIsDone(false)}>
                            Back
                        </Button>
                    </Box>
                    <Button
                        onClick={handleBuyInvoiceSave}
                        disabled={isDisabled}
                    >
                        Save
                    </Button>
                </>
            )}
        </Box>
    );
};

export default AddBuyInvoice;
